import React, { memo } from "react";
import { Conversation } from "@/services/chat";
import { cn } from "@/lib/utils";
import { format } from "date-fns";
import { Badge } from "@/components/ui/badge";

interface ConversationItemProps {
  conversation: Conversation;
  isSelected: boolean;
  onClick: () => void;
  userRole: string | null; // Passado como prop para evitar múltiplas chamadas useRole
}

export const ConversationItem: React.FC<ConversationItemProps> = memo(({ 
  conversation, 
  isSelected, 
  onClick,
  userRole
}) => {
  const isUserMentor = userRole === "mentor";
  
  // Determine the name to display based on user role
  // For mentor-to-mentor conversations, show the "other" person's name
  const displayName = isUserMentor 
    ? conversation.player_name 
    : conversation.mentor_name;

  // Reduzido logging para apenas casos problemáticos
  if (!displayName) {
    console.warn("⚠️ [ConversationItem] Nome de exibição vazio:", {
      conversation_id: conversation.id,
      user_role: userRole,
      mentor_name: conversation.mentor_name,
      player_name: conversation.player_name,
      mentor_id: conversation.mentor_id,
      player_id: conversation.player_id
    });
  }
  
  const formattedTime = conversation.last_message_at 
    ? format(new Date(conversation.last_message_at), 'dd/MM/yyyy')
    : '';

  return (
    <div
      onClick={onClick}
      className={cn(
        "px-4 py-3 cursor-pointer hover:bg-[#1A2233] border-l-4 transition-all duration-200",
        isSelected 
          ? "bg-[#1A2233] border-[#00B6F0]" 
          : "border-transparent"
      )}
    >
      <div className="flex justify-between items-center">
        <h3 className="font-medium text-white truncate">{displayName || "Nome não disponível"}</h3>
        <span className="text-xs text-gray-400">{formattedTime}</span>
      </div>
      
      <div className="flex justify-between items-center mt-1">
        <p className="text-sm text-gray-400 truncate">
          {conversation.last_message || "Nenhuma mensagem ainda"}
        </p>
        
        {conversation.unread_count > 0 && (
          <Badge className="ml-2 bg-[#00B6F0] text-white">
            {conversation.unread_count}
          </Badge>
        )}
      </div>
    </div>
  );
});

ConversationItem.displayName = "ConversationItem";
